<template>
  <v-container fluid id="foot">
    <v-layout wrap>
      <v-flex class="version" text-xs-center>
        <span>{{ $t('message.footer.copyright', { anio: $moment().format('YYYY') }) }} </span>
        <a href="https://sede.cnmc.gob.es/politica-privacidad-y-aviso-legal" target="_blank">
          {{ $t('message.footer.avisolegal') }}</a
        >
        <span @click="showAlert = true"
          ><a href="#"
            ><u> {{ $t('message.footer.contacto') }} </u></a
          ></span
        >
        <span>{{ date }} v{{ version }}/{{ versionApi }}</span></v-flex
      >
    </v-layout>
    <!-- Ventana modal de alerta -->
    <Modal id="modalSelecEmpresa" :modalShow="showAlert" size="600" title="Contacto">
      <p>{{ $t('message.footer.contactoText') }}</p>
      <p class="negrita text-xs-center">{{ $t('message.footer.correo') }}</p>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="showAlert = false">
          Aceptar
        </v-btn>
      </v-card-actions>
    </Modal>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { Modal } from '@/components';
import { version, date } from '../../../../package.json';
export default {
  data() {
    return {
      version: version,
      date: date,
      showAlert: false
    };
  },
  components: {
    Modal
  },

  computed: {
    ...mapGetters({
      versionApi: 'versionApi',
      autenticado: 'userAuthenticated'
    })
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import 'src/resources/styles/variables.scss';
#foot {
  font-size: 1.2rem;
  color: $color-text-secondary;
  a {
    padding-left: 50px;
    color: $color-text-secondary;
  }
  span {
    padding-left: 50px;
  }
  .version {
    white-space: nowrap;
  }
}
@media (max-width: 1200px) {
  .version {
    display: none;
  }
}
</style>
